module.exports = __webpack_public_path__ + "static/media/api-programming@mobile.5f159921.svg";